import React from "react";

export const EarlyWarningSystem = React.lazy(
  () =>
    import("@/features/early-warning-system/pages/EarlyWarningSystemPage.tsx"),
);
